import React, { useState, useEffect } from 'react';
export function CountdownTimer() {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 23;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (num: number) => String(num).padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 md:gap-3" role="timer" aria-live="off" data-id="element-52" data-mp="34pgx6vizm2lw">
      <TimeBox value={pad(time.hours)} data-id="element-53" data-mp="2zsgsanxvj5wd" />
      <span className="font-display text-2xl text-primary/40" data-id="element-54" data-mp="1c05h7s22ybpw">:</span>
      <TimeBox value={pad(time.minutes)} data-id="element-55" data-mp="1c31f5gdxh0ec" />
      <span className="font-display text-2xl text-primary/40" data-id="element-56" data-mp="1h01ktq6v814x">:</span>
      <TimeBox value={pad(time.seconds)} data-id="element-57" data-mp="122ipg4zompoi" />
    </div>;
}
function TimeBox({
  value
}: {
  value: string;
}) {
  return <div className="bg-white border border-primary/10 rounded-xl shadow-sm px-4 py-3 md:px-5 md:py-4 min-w-[64px] md:min-w-[76px]" data-id="element-58" data-mp="1712bs6i6u3he">
      <span className="font-display font-black text-accent text-2xl md:text-3xl leading-none" data-id="element-59" data-mp="1ushjyfwnbf0k">
        {value}
      </span>
    </div>;
}